import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 16,
    backgroundColor: '#FFFFFF',
    position: 'relative',
    overflowY: 'auto',
    boxShadow: "0 8px 28px rgba(0,0,0,0.14)",
    '& .MuiIconButton-root': {
      padding: 4
    },
  },

  dialogStyle: {
    borderRadius: '12px !important',
    maxHeight: "100%",
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%'
    }
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  title: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "400",
    textAlign: 'center',
    margin: 16,
  },

  cardBody: {
    width: '100%',
    padding: '20px 28px 20px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px'
    },
  },

  serviceStrip: {
    background: '#f6f0e3',
    borderBottom: '1px solid #ead58b',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: '10px 16px',
    textAlign: 'center'
  },

  serviceStripText: {
    margin: 0,
    color: '#8a5b14',
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Montserrat'
  },

  serviceStripLink: {
    color: '#8a5b14',
    fontWeight: 700,
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  heroTitle: {
    color: '#0f172a',
    fontFamily: 'Montserrat',
    fontSize: 24,
    fontWeight: 700,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      lineHeight: 1.1
    }
  },

  heroSubTitle: {
    color: '#5b667a',
    fontFamily: 'Montserrat',
    fontSize: 16,
    lineHeight: 1.5,
    textAlign: 'center',
    margin: '8px auto 18px',
    maxWidth: 520,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },

  contactCard: {
    border: '1px solid #d7dde8',
    borderRadius: 12,
    background: '#f8fbff',
    padding: '12px 14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  contactHeading: {
    color: '#7c8aa5',
    fontSize: 13,
    fontWeight: 700,
    fontFamily: 'Montserrat',
    letterSpacing: '0.5px'
  },

  contactValue: {
    color: '#2d3a55',
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Montserrat'
  },

  contactValuesRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    flexWrap: 'wrap'
  },

  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },

  contactEditGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    marginTop: 8,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },

  contactFieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },

  contactFieldLabel: {
    color: '#8592a8',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'Montserrat'
  },

  contactInlineInput: {
    height: 34,
    border: '1px solid #cfd7e6',
    borderRadius: 8,
    padding: '0 10px',
    fontFamily: 'Montserrat',
    fontSize: 15,
    color: '#2d3a55',
    outline: 'none',
    backgroundColor: '#fff',
    '&:focus': {
      border: '1px solid #9aa8c1',
      boxShadow: '0 0 0 2px rgba(40, 98, 173, 0.12)'
    }
  },

  contactInfoIcon: {
    fontSize: 16,
    color: '#6f809e'
  },

  editLink: {
    color: '#0a7b73',
    fontSize: 14,
    fontWeight: 700,
    fontFamily: 'Montserrat',
    textDecoration: 'underline',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },

  fieldSection: {
    paddingTop: 8
  },

  notesLabel: {
    color: 'rgb(51, 65, 85)',
    fontFamily: 'Montserrat',
    fontSize: 14,
    lineHeight: 1.3,
    fontWeight: 700,
    marginBottom: 8,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },

  optionalText: {
    color: '#8f9ab0',
    fontWeight: 500,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },

  statusContainer: {
    marginBottom: 20,
    marginTop: 20
  },

  statusBody: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "bold",
  },

  bodyText: {
    color: "#0C0B0B",
    fontFamily: "Montserrat",
    fontSize: '1.4em',
    marginBottom: 30,
    marginTop: 0,
  },

  btn: {
    width: 188,
    fontFamily: "Montserrat",
    fontSize: '1.5em',
    fontWeight: "600",
  },

  flexBox: {
    display: 'flex',
    alignItems: 'center',
  },
 
  statusTitle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 20,
    fontWeight: "700",
    marginTop: 0,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      fontWeight: "600"
    },
  },

  paragraph: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 20,
    fontWeight: "500",
    [theme.breakpoints.down('sm')]: {
      fontSize: 15
    },  
  },
 
  statusSubTitle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 18,
    fontWeight: "500",
    lineHeight: "30px",
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
  },

  continueBtn: {
    fontFamily: "Montserrat",
    marginBottom: 20,
    fontSize: '1.4em',
    fontWeight: '600',
    width: 160,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      width: 105,
      height: '30px'
    },
  },

  buttonContainer: {
    textAlign: 'center',
    margin: '20px 10px'
  },

  checkBoxLabel: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: "500"
  },
 
  skipBtn: {
    width: 160,
    fontFamily: "Montserrat",
    fontSize: '1.4em',
    fontWeight: "600",
    letterSpacing: "0.53px",
    lineHeight: "19px",
    textAlign: "center",
    border: "2px solid",
    height: '40px',
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
    borderColor: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      width: 105,
      fontSize: 14,
      height: '30px'
    },
  },
 
  titleBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    padding: '12px 2em',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  cardIcon: {
    width: 18,
    height: 18,
    color: "#007FFF"
  },

  cardContent2: {
    display: 'flex',
    marginBottom: 20,
    marginTop: 20
  },

  radioBtn: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 5,
      paddingRight: 5
    },
  },

  cardTitleBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    padding: '12px 2em',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  labelText: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "700",
  },

  textareaSection: {
    paddingTop: '16px',
    '& .MuiFormLabel-root': {
      asterisk: {
        color: 'red',
        '&$error': {
          color: 'red'
        },
      }
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: '15px'
    },
  },

  textArea: {
    color: "#202020",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 500,
    width: '100%',
    padding: "14px",
    height: '90px',
    border: 'none',
    backgroundColor: '#f9fbff',
    outline: 'none',
    borderRadius: '12px',
    border: '1px solid #d6dce7',
    "&::placeholder": {    
      color: '#98a4bb',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      lineHeight: 1
     }
  },

  textBox: {
    width: '100%',
    '& .MuiFormLabel': {
      asterisk: {
        color: 'red',
        '&$error': {
          color: 'red'
        },
      }
    }
  },

  propertyLabelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },

  propertyTooltipIcon: {
    color: '#8ea0ba',
    fontSize: 18,
    cursor: 'pointer',
    width: 20,
    height: 20
  },

  labelAsterisk: {
    color: "red"
  },

  textAreaValidation: {
    color: '#8f9ab0',
    fontSize: 14,
    float: 'right'
  },

  inputStyle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 24
  },
 
  labelStyle: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "400",
  },

  selectGoalLabel: {
    color: '#98a4bb !important',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 400,
    '&.Mui-focused': {
      color: '#98a4bb !important'
    }
  },

  viewconsent: {
    color: '#0a7b73',
    cursor: "pointer",
    textDecoration: 'underline',
    fontFamily: "Montserrat",
    fontSize: 12,
    fontWeight: 600,
    marginLeft: 34
  },

  consentSection: {
    marginTop: 10,
    '& .MuiFormControlLabel-root': {
      alignItems: 'flex-start',
      marginLeft: 0,
      marginRight: 0
    }
  },

  consentDialogPaper: {
    borderRadius: 16,
    overflow: 'hidden'
  },

  consentDialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: '14px 20px',
    borderBottom: '1px solid #e6e8ef'
  },

  consentDialogTitle: {
    color: '#1b2233',
    fontFamily: 'Montserrat',
    fontSize: 22,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    }
  },

  consentCloseIcon: {
    color: '#8ea0ba',
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)'
  },

  consentDialogBody: {
    padding: '18px 20px 8px',
    maxHeight: '58vh',
    overflowY: 'auto'
  },

  consentHtmlBody: {
    fontFamily: 'Montserrat',
    color: '#5e6d84',
    fontSize: 15,
    lineHeight: 1.5,
    '& .box': {
      margin: 0,
      padding: 0
    },
    '& .info': {
      marginTop: 0,
      marginBottom: 16,
      color: '#5e6d84',
      fontSize: 15,
      lineHeight: 1.5,
      fontFamily: 'Montserrat'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      '& .info': {
        fontSize: 14
      }
    }
  },

  consentDialogFooter: {
    padding: '0 20px 18px'
  },

  consentCloseBtn: {
    width: '100%',
    height: 48,
    borderRadius: 10,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 700
  },

  infoBox: {
    width: '100%',
    alignItems: 'center',
    backgroundColor: '#FFF0F0',
    borderRadius: 4,
    padding: '0.5em',
    borderRadius: '4px',
    border: "1px solid #F85757",
  },

  infoTopBox: {
    width: '100%',
    alignItems: 'center',
    backgroundColor: '#F4F4F4',
    borderRadius: 8,
    padding: '0.5em',
    borderRadius: '4px',
    border: "1px solid #D9D9D9",
    marginBottom: 20,
    marginTop: 5
  },

  feelFree: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: "15px",
    letterSpacing: "0.31px",
    lineHeight: "18px",
    fontWeight: "400",
    padding: 10,
    maxHeight: '100px',
    overflow: "auto"
  },

  closeIcon: {
    position: 'absolute',
    right: 10,
    top: 62,
    paddingTop: 8,
    [theme.breakpoints.down('sm')]: {
        right: 2,
        top: 70
    }
  },

  inputStyle: {
    color: "#535D6D",
    fontWeight: "500"
  },

  errorMsg: {
    fontSize: '1em',
    fontWeight: '600',
    marginBottom: 10,
    marginTop: 10,
    fontFamily: 'Montserrat',
    color: "red"
  },

  primaryCtaBtn: {
    width: '100%',
    height: 46,
    borderRadius: 14,
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 600,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      height: 42
    }
  },

  validationError: {
    color: "red",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontWeight: "600",
    letterSpacing: "0.31px",
    lineHeight: "18px",
    marginTop: '5px'
  },

  cardBody2: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    padding: '8px 2em',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  heading:{
    color: '#198100',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 'normal',
    margin: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
},

gotItButton: {
  width: '100%',
  textAlign: 'center',
  backgroundColor: "#fff",
  marginTop: 30,
  [theme.breakpoints.down('sm')]: {
    padding: '8px 80px 0px',
    width: '94%'
  },
},

successBody: {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '40px 12px 40px',
  [theme.breakpoints.down('sm')]: {
    padding: '32px 20px 36px'
  }
},

successCheckImage: {
  width: 64,
  height: 64,
  objectFit: 'contain',
  marginBottom: 20
},

successTitle: {
  color: '#0f172a',
  fontFamily: 'Montserrat',
  fontSize: 24,
  fontWeight: 800,
  textAlign: 'center',
  marginBottom: 12,
  [theme.breakpoints.down('sm')]: {
    fontSize: 20
  }
},

successSubTitle: {
  color: '#5b667a',
  fontFamily: 'Montserrat',
  fontSize: 16,
  fontWeight: 400,
  textAlign: 'center',
  lineHeight: 1.6,
  marginBottom: 24,
  [theme.breakpoints.down('sm')]: {
    fontSize: 14
  }
},

successPhonePill: {
  border: '1px solid #d7dde8',
  borderRadius: 10,
  padding: '12px 8px',
  backgroundColor: '#f8fbff',
  textAlign: 'center'
},

successPhonePillText: {
  color: '#4b5878',
  fontFamily: 'Montserrat',
  fontSize: 15,
  fontWeight: 400,
  '& strong': {
    color: '#0f172a',
    fontWeight: 700
  }
},


typography: {
  color: 'rgb(51, 65, 85)',
  fontFamily: "Montserrat",
    fontSize: 14,
    lineHeight: "28px",
    fontWeight: 700,
    marginBottom: 8,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      lineHeight: '22px'
    }
},

eligible:{
  color: '#1B1B1B',
  textAlign: 'center',
  fontFamily: 'Montserrat',
  fontSize: 16,
  fontWeight: 500,
  lineHeight: 'normal',
  margin: 20,
  [theme.breakpoints.down('sm')]: {
    fontSize: 14
  },
},

 allSetcloseIcon: {
    position: 'absolute',
    right: 10,
    top: 10,
    paddingTop: 8,
    [theme.breakpoints.down('sm')]: {
        right: 2
    }
  },

  gotItBtn: {
    padding: '0 28px',
    height: 46,
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 600,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      height: 42
    }
  },

}));
